import styled from 'styled-components';
import { withMargins } from '../../mixins';
export const DividerWrapper = styled.hr `
  margin: 0;
  height: 1px;
  border: none;
  background-color: ${({ inverted = false }) => inverted ? 'var(--divider-inverted-background-color)' : 'var(--divider-default-background-color)'};
  ${withMargins}
`;
